export default __webpack_public_path__ + "static/media/cba6cbe8503324475d177eec5a0b56541577454070271.4409eb7c.webp";